import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import type User from 'modules/core/store/models/User'

interface Props {
  user: User
  onClose: () => void
}

const RemoveAccessModal = ({ user, onClose }: Props) => {
  const { running, performAction: onSubmit } = useAsyncAction(async () => {
    const { success } = await asyncAction(() => user.destroy())

    if (success) {
      onClose()
    }
  })

  const name = user.fullName()

  return (
    <Modal
      illustration="input-field"
      title={i18n.t('settings.permissions.users.confirm_delete.title', {
        name,
      })}
      description={i18n.t('settings.permissions.users.confirm_delete.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Button disabled={running} type="negative" submit>
          {i18n.t('settings.permissions.users.delete')}
        </Button>
      }
    />
  )
}

export default observer(RemoveAccessModal)
